const apiConstants = {
    NEWS:'/news',
    COLUMN: '/column'
}

export default apiConstants;
